import React from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, IconButton, Typography } from '@mui/material'

export const BreakdownButton = ({ value, label, onClick, showIcon = true }) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <Typography variant='body2' fontWeight={600}>
      {value}
    </Typography>
    {showIcon && onClick && (
      <IconButton size='small' sx={{ p: 0.2, ml: 0.25 }} onClick={onClick} aria-label={label}>
        <InfoOutlinedIcon sx={{ fontSize: 15, color: 'text.disabled' }} />
      </IconButton>
    )}
  </Box>
)
